<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Pool } from "@/models/pool.model";
import { getProbeLabel } from "@/shared/utils/probes";
import {
  getAlertSpecialLine,
  getAlertExt,
  getAlertNameOverride,
} from "@/shared/utils/alerts";

export default defineComponent({
  props: {
    alert: {
      required: true,
      type: Object as PropType<Pool["alerts"][number]>,
    },
    pool: {
      required: true,
      type: Object as PropType<Pool>,
    },
  },
  computed: {
    color() {
      if (this.alert.level >= 4) {
        return "bg-alert";
      } else if (this.alert.level >= 2) {
        return "bg-warning";
      } else {
        return "bg-info";
      }
    },
    specialLine(): string | null {
      return getAlertSpecialLine(
        this.alert.code,
        this.alert.param,
        this.pool.AqPACType
      );
    },
    alertExt(): string | null {
      return getAlertExt(this.alert.code, this.alert.param, this.pool);
    },
    nameOverride(): string | null {
      return getAlertNameOverride(this.alert.code, this.alert.param);
    },
    probe() {
      if ([1, 7, 8, 10, 36].includes(this.alert.code)) {
        return this.$t(getProbeLabel(this.alert.param)) + " ";
      }
      return "";
    },
    formattedDate() {
      return this.alert.initialDate.toLocaleString([], {
        dateStyle: "short",
        timeStyle: "short",
      });
    },
  },
});
</script>

<template>
  <div>
    <div v-if="specialLine" class="flex items-center gap-2">
      <div :class="`${color} h-[7px] w-[7px] ml-1 rounded-3xl flex-shrink-0`" />
      <div class="font-medium flex-grow whitespace-pre-line">{{ specialLine }}</div>
      <div class="text-xs flex-shrink-0">{{ formattedDate }}</div>
    </div>
    <div v-else class="flex items-center gap-2">
      <div :class="`${color} h-[7px] w-[7px] ml-1 rounded-3xl flex-shrink-0`" />
      <div class="font-medium flex-grow">
        <template v-if="nameOverride">{{ nameOverride }}</template>
        <template v-else
          >{{ probe }}{{ $t(`Alr${alert.code}`)
          }}{{ alertExt ? ` (${alertExt})` : "" }}</template
        >
      </div>
      <div class="text-xs flex-shrink-0">{{ formattedDate }}</div>
    </div>
  </div>
</template>
